export const INITIAL_STATE = {
  id: null,
};

export const update = (state, action) => {
  return {
    ...state,
    id: action.payload,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ADD_ID_DATA":
      return update(state, action);
    case "RESET_ID_DATA":
      return INITIAL_STATE;
    default:
      return state;
  }
};
